import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common-service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'app-trending-quesions',
  templateUrl: './trending-quesions.component.html',
  styleUrl: './trending-quesions.component.scss',
})
export class TrendingQuesionsComponent implements OnInit {
  trending_questions: any;
  availableCollections: any;
  selectedCollection: any;
  loader = true;
  emptymessage = '';
  rows: number = 10;
  totalrecords = 0;
  first: number = 0;
  pagenumber: number = 1;
  searchTerm: any;
  searchInputChanged = new Subject<string>();
  availableFilter = [
    { searchFilter: 'All' },
    { searchFilter: 'Verified' },
    { searchFilter: 'Unverified' },
  ];
  selectedSearchOption: any = 'All';
  documentId: any;
  isbookmarked: boolean = false;
  expandedRows: Set<number> = new Set();
  collection_id: any;
  questionDocuments: any;
  loaderDoc: boolean=false;

  constructor(
    private api: CommonService,
    private messageService: MessageService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.api.getMethod('get-collections/v2').subscribe((data: any) => {
      this.availableCollections = data;
      this.selectedCollection = this.getCollection(data)
      setTimeout(() => {
        this.loadQuestions();
      }, 1000);
    });
    this.searchInputChanged.pipe(debounceTime(300)).subscribe((value) => {
      this.first = 0;
      this.pagenumber = 1;
      if (value.trim()) {
        this.searchTrendingQuestions(this.pagenumber);
      } else {
        this.trendingApiBasedOnCollection();
      }
    });
  }
  onSearchInputChange() {
    this.searchInputChanged.next(this.searchTerm);
  }

  trendingApiBasedOnCollection() {
    let payload = {
      collection_name: this.selectedCollection,
      limit: 10,
      page: this.pagenumber,
      filter: this.selectedSearchOption,
    };
    this.api.postMethod('collection/trending/v2', payload).subscribe({
      next: (data: any) => {
        this.loader = false;
        this.trending_questions = data.trendingQuestions;
        this.totalrecords = data.totalQuestionCount;
      },
      error: (error: any) => {},
    });
  }
  searchTrendingQuestions(page: number = 1) {
    this.loader = true;
    this.pagenumber = page;
    const payload = {
      collection_name: this.selectedCollection,
      searchQuery: this.searchTerm.trim(),
      limit: this.rows,
      page: this.pagenumber,
      filter: this.selectedSearchOption,
    };
    this.api.postMethod('collection/trending/v3', payload).subscribe({
      next: (res: any) => {
        this.loader = false;
        this.trending_questions = res.trendingQuestions || [];
        this.totalrecords = res.totalQuestionCount || 0;
      },
      error: (err) => {
        this.loader = false;
        console.error(err);
      },
    });
  }

  onPageChange(event: any) {
    this.loader = true;
    this.first = event.first;
    let nextPage = event.page + 1;
    if (this.searchTerm?.trim()) {
      this.searchTrendingQuestions(nextPage);
    } else {
      this.pagenumber = nextPage;
      this.trendingApiBasedOnCollection();
    }
  }
  private loadQuestions() {
    if (this.searchTerm?.trim()) {
      this.searchTrendingQuestions(1);
    } else {
      this.trendingApiBasedOnCollection();
    }
  }

  changeSearchOption(e: any) {
    this.loader = true;
    this.selectedSearchOption = e.value;
    this.loadQuestions();
  }

  changeCollection(e: any, availableCollections: any) {
    this.selectedCollection = e.value;
    this.pagenumber = 1;
    localStorage.setItem('selectedCollection', this.selectedCollection);
    this.getCollection(availableCollections)
    this.loadQuestions();
  }

  fnQuesBookmark(questions: any) {
    let body = {
      questionId: questions.question_id,
      collectionId: this.collection_id,
      collection_name: this.selectedCollection
    };
    this.api
      .postMethod(`question/bookmark`, body)
      .subscribe({
        next: (response: any) => {
          if (response.data.bookmarkSave == true) {
            this.isbookmarked = true;
          } else {
            this.isbookmarked = false;
          }
          this.messageService.add({
            severity: 'success',
            detail: response.message,
          });
          this.loadQuestions();
        },
        error: (error: any) => {
          console.error('Error updating document', error);
        },
      });
  }

  pinUnpin(item: any) {
    let payload = {
      question: item.question,
      collection_name: this.selectedCollection,
    };
    this.api.postMethod('collection/question-pin-toggle', payload).subscribe({
      next: (data: any) => {
        // this.trendingApiBasedOnCollection()
        this.messageService.add({ severity: 'success', detail: data.message });
        return (item.pinned = data.is_pinned);
      },
      error: (error: any) => {
        this.messageService.add({
          severity: 'error',
          detail: 'Error in updating',
        });
      },
    });
  }
  getAbsoluteUrl(question: any): string {
    const tree = this.router.createUrlTree(['/faq'], {
      queryParams: { 
        questionid: question.question_id, 
        og_question: question.original_question ? question.original_question : question.question
      },
    });
    return `${window.location.origin}${this.router.serializeUrl(tree)}`;
  }
  viewQuest(question: any) {
    const url = this.getAbsoluteUrl(question);
    localStorage.removeItem('OC_ID')
    window.open(url, '_blank');
  }

  getQuestionDocuments(question: any){
    // this.loader = true;
    this.loaderDoc= true;
    const payload = {
      collection_name: this.selectedCollection,
      question_id: question.question_id
    };
    this.api.postMethod('question/documents', payload).subscribe({
      next: (res: any) => {
        this.loaderDoc= false;
        this.questionDocuments = res?.documents || [];
      },
      error: (err) => {
        this.loaderDoc= false;
        console.error(err);
      },
    });
  }

  toggleRow(row: any) {
    if (this.expandedRows.has(row.question_id)) {
      this.expandedRows.delete(row.question_id);
      this.questionDocuments= [];
    } else {
      this.expandedRows.clear(); // For accordion behavior; remove this line for multi-expand
      this.expandedRows.add(row.question_id);
      this.getQuestionDocuments(row)
    }
  }

  isRowExpanded(row: any): boolean {
    return this.expandedRows.has(row.question_id);
  }

  deletedoc(data: any, doc: any) {
    if (this.collection_id) {
      let body = {
        document_id: Number(doc.document_id),
        collection_id: Number(this.collection_id),
        question_id: Number(data.question_id)
      };

      this.api.postMethod('removeLinkedDoc/trending_question', body).subscribe({
        next: (data) => {
          this.expandedRows.clear(); // For accordion behavior; remove this line for multi-expand
          this.messageService.add({
            severity: 'success',
            detail: data.message,
          });
          this.loadQuestions();
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', detail: err.message });
          console.error('DeleteError', err);
        },
      });
    }
  }

  confirmDelete(question: any, document: any, event: Event) {
    // event.preventDefault();
    this.confirmationService.confirm({
      message: `Are you sure you want to delete <b>${document.document_name}</b>?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deletedoc(question, document);
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelled',
          detail: 'Document deletion was cancelled',
        });
      },
    });
  }


  deleteQuestion(data: any) {
    if (this.selectedCollection) {
      let body = {
        question_id: Number(data.question_id),
        collection_name: this.selectedCollection
      };

      this.api.postMethod('question/delete', body).subscribe({
        next: (data) => {
          this.messageService.add({
            severity: 'success',
            detail: data.message,
          });
          this.loadQuestions();
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', detail: err.message });
          console.error('DeleteError', err);
        },
      });
    }
  }

  confirmQuestionDelete(question: any) {
    this.confirmationService.confirm({
      message: `Are you sure you want to delete <b>${question.question}</b>?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteQuestion(question);
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: 'Cancelled',
          detail: 'Document deletion was cancelled',
        });
      },
    });
  }

  getCollection(data: any){
    let collectionName= localStorage.getItem('selectedCollection') ? localStorage.getItem('selectedCollection')
        : data[0].collectionName;
      data.forEach((collection: any) => {
        if (collection.collectionName == collectionName) {
          this.collection_id = collection.collection_id;
        }
      });
    return collectionName
  }
}
